import { ConfigurationAdminEnum } from '@/generated/graphql/types';

import { useLearningUserKnowledgeHubConfigQueryQuery } from './get-knowledge-hub-config-query.v5.generated';

type TUseGetKnowledgeHubConfigProps = {
  organizationId: string;
};

/**
 * Shared Knowledge Hub config for an organization: whether the org has Knowledge Hub
 * enabled (`hasKnowledgeHub`) and whether its admin has toggled on Crehana's own
 * catalog (`hasCrehanaCatalog`) and/or third-party catalog content
 * (`hasThirdPartyCatalog`). Used by `my-courses-with-filters` and `StartSectionNew` —
 * reuse this hook instead of adding a new `knowledge_hub_config` query elsewhere.
 */
export const useGetKnowledgeHubConfig = ({
  organizationId,
}: TUseGetKnowledgeHubConfigProps) => {
  const { data, loading, error } = useLearningUserKnowledgeHubConfigQueryQuery({
    context: { clientName: 'v5' },
    variables: { organizationId },
    skip: !organizationId,
  });

  const knowledgeHubConfig = data?.knowledge_hub_config.knowledge_hub_config;
  const configAdminDetail = knowledgeHubConfig?.config_admin_detail;

  return {
    hasKnowledgeHub: knowledgeHubConfig?.has_knowledge_hub,
    hasCrehanaCatalog:
      configAdminDetail?.has_crehana_content_available ===
      ConfigurationAdminEnum.Active,
    hasThirdPartyCatalog:
      configAdminDetail?.has_third_party_content_available ===
      ConfigurationAdminEnum.Active,
    loading,
    error,
  };
};
